import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router';
import './OTPVerification.css';
import image from './touche logo.png';
import settings from 'config/settings'

const OTPVerification: React.FC = () => {
    const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

    const history = useHistory()

    const handleInput = (index: number, e: React.FormEvent<HTMLInputElement>) => {
        const value = (e.target as HTMLInputElement).value.replace(/\D/g, '');
        if (value) {
            const newOtp = [...otp];
            newOtp[index] = value.slice(-1);
            setOtp(newOtp);

            if (index < 5) {
                inputRefs.current[index + 1]?.focus();
            }
        }
    };

    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const newOtp = [...otp];

            if (otp[index]) {
                newOtp[index] = ''; 
            } else if (index > 0) {
                newOtp[index - 1] = '';
                inputRefs.current[index - 1]?.focus();
            }

            setOtp(newOtp);
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const enteredOtp = otp.join('');
        const emailAddress = localStorage.getItem('emailAddress');

        if (!emailAddress) {
            setError('Email address not found. Please try again.');
            return;
        }

        if (enteredOtp.length !== 6) {
            setError('Please enter a valid 6-digit OTP.');
            return;
        }

        setError('');

        try {
            const apiUrl = `${settings.userApi}/user/delete`;

            const response = await fetch(apiUrl, {
                method: 'Delete',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    emailAddress, 
                    otpStore: enteredOtp 
                }),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(errorResponse.error || 'Failed to verify OTP. Please try again.');
            }

            const successResponse = await response.json();
            setSuccess(successResponse.message);
            
            localStorage.removeItem('emailAddress');
            setTimeout(() => {
                setSuccess('');
                setOtp(Array(6).fill(''));
                inputRefs.current[0]?.focus();
                window.location.href = settings.playerWebUrl
            }, 5000);            
            
        } catch (err) {
            if (err instanceof Error) {
                setError(err.message || 'Something went wrong. Please try again.');
            } else {
                setError('An unknown error occurred.');
            }
        }
    };

    return (
        <div className="container">
            <div style={{ width: '400px'}}>
                <h2>Enter OTP</h2>
                <div style={{ marginBottom: '50px', marginTop: '50px' }}>
                    <img width={375} height={75} src={image} alt="Logo" className='delete-account-logo' />
                </div>
                <form onSubmit={handleSubmit} className="form">
                    <div className="otp-group" style={{marginTop: '100px',marginBottom: "20px"}}>
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                type="text"
                                maxLength={1}
                                value={digit}
                                onInput={(e) => handleInput(index, e)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                inputMode="numeric"
                            />
                        ))}
                    </div>
                    {error && <p className="error" style={{textAlign : "center",width: "100%",lineHeight: "normal",marginBottom : "10px"}} >{error}</p>}
                    {success && <p className="success" style={{textAlign : "center",width: "100%",lineHeight: "normal",marginBottom : "10px"}}>{success}</p>}
                    <button style={{marginTop: '20px'}} type="submit" disabled={otp.join('').length !== 6} className='delete-account-verify-btn'>Verify</button>
                </form>
            </div>
        </div>
    );
};

export default OTPVerification;
